import { updateProfileAction } from '../update'
import { PROFILES_ACTION } from '../../constants'
import { PROFILE_KEY } from '../../../../../models/profile/constants'

export function updateGymAccessProfileAction (value) {
  return (dispatch) => {
    dispatch(updateProfileAction({
      type: value
        ? PROFILES_ACTION.UPDATE_GYM_ACCESS
        : PROFILES_ACTION.DELETE_GYM_ACCESS,
      payload: {
        key: PROFILE_KEY.GYM_ACCESS,
        value
      }
    }))
  }
}
